import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Logo from './../../assets/images/lcg-logo@3x.png'
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import SubmitIcon from './../../assets/images/more-right-white.png'
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import IconFacebook from './../../assets/images/icon-facebook-circle.png'
import IconMedium from './../../assets/images/icon-medium-circle.png'
import IconYoutube from './../../assets/images/icon-youtube-circle.png'
import IconTwitter from './../../assets/images/icon-twitter-circle.png'
import IconLinkedin from './../../assets/images/icon-linkedin-circle.png'
import { useHistory, Link } from 'react-router-dom'
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import Validator, { validation, conactFormData, getMultilevelValue } from 'utils/validator';
import OtherActions from 'stores/leadbest-official-website/other/actions'
import Snackbar from './../contact/Snackbar'
import { injectIntl, FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    root: {
        background: "#001229",
        padding: "77px 0px 42px 0px",
        color: "#fff",
        [theme.breakpoints.down('sm')]: {
            padding: "40px 0px",
        },
        "& .footer-block": {
            maxWidth: "1300px",
            margin: "0px auto"
        },
        "& .logo-block": {
            width: "100%",
            padding: "0px 24px"
        },
        "& .logo": {
            width: "120px",
            height: "35.4px"
        },
        "& .nav-block": {
            margin: "40px 0px",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
        },
        "& .block-title": {
            margin: "0px 0px 16px 0px",
            padding: "0px 24px",
            fontSize: "16px",
            fontWeight: "normal",
            "&.golden": {
                color: "#efc879",
                fontWeight: "500"
            },
            "&.subscription": {
                padding: "0px",
            }
        },
        "& .divider": {
            margin: "0px 0px 16px 24px",
            width: "20px",
            height: "2px",
            background: "#efc879"
        },
        "& .block": {
            [theme.breakpoints.down('md')]: {
                marginBottom: "50px"
            }
        },
        "& .first-block": {
            [theme.breakpoints.down('md')]: {
                width: "50%"
            },
            [theme.breakpoints.down('sm')]: {
                width: "100%"
            }
        },
        "& .second-block": {
            padding: "0px 24px",
            width: "460px",
            borderRight: "2px solid rgba(255,255,255,0.1)",
            [theme.breakpoints.down('md')]: {
                width: "50%",
                borderRight: "unset",
            },
            [theme.breakpoints.down('sm')]: {
                width: "100%"
            }
        },
        "& .third-block, .forth-block, .fifth-block": {
            [theme.breakpoints.down('md')]: {
                width: "33%",
            },
            [theme.breakpoints.down('sm')]: {
                width: "50%",
            },
        },
        "& .footer-button": {
            justifyContent: "flex-start",
            color: "rgba(255,255,255,0.7)",
            transition: "0.25s",
            "&:hover": {
                backgroundColor: "rgba(239,200,121,0.1)",
                color: "#efc879"
            }
        },
        "& .MuiListItem-root": {
            padding: "0px 16px",
        },
        "& .social-block": {
            width: "100%",
            padding: "0px 24px",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap"
        },
        "& .social-title": {
            opacity: "0.5",
            marginRight: "25px",
            [theme.breakpoints.down('xs')]: {
                width: "100%"
            }
        },
        "& .social-button": {
            width: "24px",
            height: "24px",
            color: "#fff",
            padding: "0px",
            marginRight: "12px",
            "& img": {
                width: "100%",
                height: "100%"
            }
        },
        "& .input-block": {
            width: "400px",
            position: "relative",
            [theme.breakpoints.down('md')]: {
                width: "300px",
            },
            [theme.breakpoints.down('sm')]: {
                width: "100%",
            }
        },
        "& .submit-icon": {
            cursor: "pointer",
            position: "absolute",
            top: "20px",
            right: "14px",
            width: "16px",
            height: "11px",
            transform: "translate(0px,-50%)"
        },
        "& .MuiInputBase-input": {
            color: "#fff"
        },
        "& .MuiFormLabel-root": {
            color: "rgba(255,255,255,0.54)"
        },
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.23)"
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.87)"
        },
    },
    copyright: {
        backgroundColor: "#000f24",
        "& .copyright": {
            color: "#fff",
            fontSize: "12px",
            maxWidth: "1300px",
            margin: "0px auto",
            width: "100%",
            padding: "24px"
        }
    },

}))
const Footer = (props: any) => {
    const { intl } = props
    const classes = useStyles()
    const dispatch = useDispatch();
    const otherSelector = useSelector((state: any) => state.leadbest.other);
    const email = otherSelector.email

    // subscription 
    const emptyFormData = { email: "" }
    const [formData, setFormData] = useState<any>({ ...emptyFormData })
    const [errorMessage, setErrorMessage] = React.useState<any>({});
    const validations: any = {
        email: [Validator.required, Validator.isEmail],
    };
    let validationField: any = ['email'];

    // const onInputChange = (e: any) => {
    //     Validator.onChangeValidate(e, validations, (res: any) => {
    //         setFormData({ ...formData, ...res.formData })
    //         setErrorMessage({ ...errorMessage, ...res.errorMessage })
    //     })
    // }

    // const onSubmit = () => {
    //     Validator.onSubmitValidate({
    //         validationField,
    //         validations,
    //         formData,
    //         onComplete: (res: any) => {
    //             setErrorMessage({ ...errorMessage, ...res.errorMessage })
    //             if (res.validBol) {
    //                 dispatch(OtherActions.postEmailRequest({ ...formData }));
    //             }
    //         }
    //     })
    // }

    function onInputChange(e: any) {
        const name = e.target.name;
        const value = e.target.value;

        let newFormData = conactFormData({ name, value, formData });
        setFormData(newFormData);

        if (validations[name]) {
            const validate = validation({ validations: validations[name], name, value });
            let newErrorMessage = { ...errorMessage, ...validate.errorMessage }
            setErrorMessage(newErrorMessage);
        }
    }

    const onSubmit = () => {
        let validBol: boolean = true;
        let newErrorMessage = { ...errorMessage }

        validationField.forEach((key: string) => {
            if (validBol && validations[key]) {
                const value = getMultilevelValue({ formData, name: key });

                const validate = validation({ validations: validations[key], name: key, value });
                newErrorMessage = { ...newErrorMessage, ...validate.errorMessage }
                validBol = validate.validBol;
            }
        });

        setErrorMessage(newErrorMessage);

        if (validBol) {
            dispatch(OtherActions.postEmailRequest({ ...formData }));
        }
    }
    useEffect(() => {
        if (!email.loaded) return;
        setFormData({ ...emptyFormData })
    }, [email.loaded])

    return (
        <footer>
            <div className={classes.root}>
                <Grid className="footer-block" container>
                    <div className="logo-block">
                        <img src={Logo} className="logo" alt="leadbest logo" />
                    </div>
                    <div className="nav-block">
                        <div className="block first-block">
                            <h4 className="block-title">
                                {intl.formatMessage({ id: "footer.menu.1" })}
                            </h4>
                            <div className="divider" />
                            <Box display="flex" flexDirection="row">
                                <List>
                                    <FooterButton name={intl.formatMessage({ id: "footer.menu.1.1" })} to='/about#team' />
                                    <FooterButton name={intl.formatMessage({ id: "footer.menu.1.2" })} to='/about#bulletin' />
                                    <FooterButton name={intl.formatMessage({ id: "footer.menu.1.3" })} to='/about#timeline' />
                                    <FooterButton name={intl.formatMessage({ id: "footer.menu.1.4" })} to='/contact' />
                                </List>
                                <List>
                                    <FooterButton name={intl.formatMessage({ id: "footer.menu.1.5" })} to='/service#force' />
                                    <FooterButton name={intl.formatMessage({ id: "footer.menu.1.6" })} to='/service#step' />
                                    <FooterButton name={intl.formatMessage({ id: "footer.menu.1.7" })} to='/news?type=ALL&page=1' />
                                    <FooterButton name={intl.formatMessage({ id: "footer.menu.1.8" })} to='/join' />
                                </List>
                            </Box>
                        </div>
                        <div className="block second-block">
                            <h4 className="block-title golden subscription">
                                {intl.formatMessage({ id: "footer.menu.2" })}
                            </h4>
                            <div className="input-block">
                                <FormControl fullWidth>
                                    <TextField
                                        disabled={email.loading}
                                        value={formData.email}
                                        name="email"
                                        autoComplete="email"
                                        color="secondary"
                                        size="small"
                                        margin="none"
                                        label={intl.formatMessage({ id: "footer.menu.2.placeholder" })} variant="outlined"
                                        onChange={onInputChange}
                                        error={!!errorMessage['email']}
                                        helperText={errorMessage['email'] ? intl.formatMessage({ id: `${errorMessage[`email`]}` }) : ''}
                                    />
                                </FormControl>
                                <img className="submit-icon" src={SubmitIcon} alt="submit-cion" onClick={onSubmit} />
                            </div>
                        </div>
                        <div className="block third-block">
                            <h4 className="block-title golden">
                                {intl.formatMessage({ id: "footer.menu.3" })}
                            </h4>
                            <div className="divider" />
                            <List>
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.3.1" })} to='/empower/Venture%20Studio%20TEXTIP' />
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.3.2" })} to='/empower/Venture%20Studio%20InstaHealth' />
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.3.3" })} to='/empower/Digital%20Empowerment%20Cosmos%20Hotel' />
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.3.4" })} to='/empower/Digital%20Empowerment%20Philips%20Acer' />
                            </List>
                        </div>
                        <div className="block forth-block">
                            <h4 className="block-title golden">
                                {intl.formatMessage({ id: "footer.menu.4" })}
                            </h4>
                            <div className="divider" />
                            <List>
                                {/* 外部連結要加 pathname */}
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.4.1" })} to={{ pathname: 'https://www.instahealth.app/?lang=true' }} />
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.4.2" })} to={{ pathname: 'https://www.belend.io/' }} />
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.4.3" })} to={{ pathname: 'https://www.macrolio.com/' }} />
                            </List>
                        </div>
                        <div className="block fifth-block">
                            <h4 className="block-title golden">
                                {intl.formatMessage({ id: "footer.menu.5" })}
                            </h4>
                            <div className="divider" />
                            <List>
                                {/* 外部連結要加 pathname */}
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.5.4" })} to={{ pathname: 'https://www.echox.app/' }} />
                                {/* <FooterButton name={intl.formatMessage({ id: "footer.menu.5.1" })} to='https://www.leadinsight.asia/' /> */}
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.5.2" })} to={{ pathname: 'https://www.leadagilex.com/' }} />
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.5.5" })} to={{ pathname: 'https://www.presurgmedia.com/' }} />
                                {/* <FooterButton name={intl.formatMessage({ id: "footer.menu.5.3" })} to='#' />
                                <FooterButton name={intl.formatMessage({ id: "footer.menu.5.4" })} to='#' /> */}
                            </List>
                        </div>
                    </div>
                    <div className="social-block">
                        {/* 外部連結要加 pathname */}
                        <p className="social-title"> {intl.formatMessage({ id: "footer.social" })}</p>
                        <IconButton className="social-button" component={Link} to={{ pathname: 'https://www.facebook.com/LeadBest.io' }}>
                            <img src={IconFacebook} alt="" />
                        </IconButton>
                        <IconButton className="social-button" component={Link} to={{ pathname: 'https://medium.com/leadbest-cn' }}>
                            <img src={IconMedium} alt="" />
                        </IconButton>
                        <IconButton className="social-button" component={Link} to={{ pathname: 'https://www.youtube.com/channel/UCpX75DUuFateiJSfPMdvJfA' }}>
                            <img src={IconYoutube} alt="" />
                        </IconButton>
                        <IconButton className="social-button" component={Link} to={{ pathname: 'https://twitter.com/medialeadbesti1' }}>
                            <img src={IconTwitter} alt="" />
                        </IconButton>
                        <IconButton className="social-button" component={Link} to={{ pathname: 'https://www.linkedin.com/company/14380351' }}>
                            <img src={IconLinkedin} alt="" />
                        </IconButton>
                    </div>
                </Grid>
                <Snackbar />
            </div>
            <div className={classes.copyright}>
                <p className="copyright">
                    {`LeadBest Consulting Group © ${new Date().getFullYear()} ALL RIGHTS RESERVED`}
                </p>
            </div>
        </footer>
    )
}
const FooterButton = (props: any) => {
    const { to, name } = props
    return (
        <ListItem>
            <Button className="footer-button" component={Link} to={to}>
                {name}
            </Button>
        </ListItem>
    )
}

export default injectIntl(Footer);